export const URL = {
    DOCUMENTS  : 'documents',
    FILTERS    : 'filters',
    REFERENCES : 'create-references-archive',
    USER_INFO  : 'auth/user-info',
    SIGN_OUT   : 'auth/sign-out',
    FEEDBACK   : 'feedback'
};
